import AddDimensionListDetails from './AddDimensionListDetails';

export default AddDimensionListDetails;
